// Report state semantics, shared by the topbar badge, the reports hub and the
// download panel so the three never disagree about what "ready" means.

// The backend writes 'todo' on a queued report and 'in_progress' on a running
// one, and older records carry 'in progress'; all three mean the same thing to
// the customer.
export const normalizeReportState = (state) => {
    const value = (state || '').replace(/ /g, '_').toLowerCase();
    return value === 'done' || value === 'failed' ? value : 'in_progress';
};

// What the customer can act on right now: a finished report they have not
// collected yet. One still being built is not news.
export const readyToDownloadCount = (reports) => (reports || []).filter(
    report => normalizeReportState(report.state) === 'done' && report.is_downloaded === false).length;

export const inProgressCount = (reports) => (reports || []).filter(
    report => normalizeReportState(report.state) === 'in_progress').length;
